<msf-summary-wrapper
  [items]="items"
  *ngIf="showMenu">
  <div
    title
    class="flex align-items-center mb-4">
    <i
      class="pi pi-arrow-left back-button"
      (click)="goBack()"></i>
    <h1 class="m-0 text-color">{{ "Administration" | translate }}</h1>
  </div>

  <div
    right
    #right
    class="p-4">
    <div class="summary-header mb-4">
      <h2 class="summary-title">{{ "Summary information" | translate }}</h2>
    </div>
  </div>
</msf-summary-wrapper>

<router-outlet></router-outlet>
